import { graphql } from '@guuru/graphql-common/gql';

export default graphql(`
  mutation HotTransferChat($id: ID!, $input: TransferInput!) {
    hotTransferChat(id: $id, input: $input)
  }
`);
